import { PropsWithChildren, useRef } from 'react';

import { createTheme, CssBaseline, StyledEngineProvider, Theme, ThemeProvider as MuiThemeProvider } from '@mui/material';

import { baseTheme } from '../../themes';

export default function ThemeProvider({ children }: PropsWithChildren) {
  const theme = useRef<Theme>(createTheme(baseTheme));

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme.current}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}
